import React from 'react';
import PropTypes from 'prop-types';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { TRACK_DIFFICULTY_BLACK } from "../../config/constants";
import { tracksWidth } from "../../config/defaults";

const Connector16CBlack16DBlack = ({ state, workState, onLabelClick }) => (
	<g id="Connector16CBlack16DBlack" transform="translate(2349.000000, 423.000000)" className="track">
		<g id="line"
			 transform="translate(0.138327, 0.932938)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
			 strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<line className="connector" x1="62.3616731" y1="173.567062" x2="155.626108" y2="261.486168"/>
		</g>
	</g>
);

Connector16CBlack16DBlack.propTypes = {};

export default Connector16CBlack16DBlack;
